<mat-card>
  <mat-card-header>
    <mat-card-title>{{ 'title.config_account_brand_name' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="form">

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'brand_name.edit_account.name' | translate }}</mat-label>
        <input matInput formControlName="name" type="text" readonly />
      </mat-form-field>

      <!-- Field: User Name -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'brand_name.edit_account.username' | translate }}</mat-label>
        <input matInput formControlName="username" type="text" required />
        <mat-error *ngIf="form.get('username')?.hasError('required')">
          {{ 'brand_name.edit_account.required_username' | translate }}
        </mat-error>
      </mat-form-field>

      <!-- Field: Password -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'brand_name.edit_account.password' | translate }}</mat-label>
        <input matInput formControlName="password" type="text" required />
        <mat-error *ngIf="form.get('password')?.hasError('required')">
          {{ 'brand_name.edit_account.required_password' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'brand_name.edit_account.cp_code' | translate }}</mat-label>
        <input matInput formControlName="cpCode" type="text" required />
        <mat-error *ngIf="form.get('cpCode')?.hasError('required')">
          {{ 'brand_name.edit_account.required_cpCode' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'brand_name.edit_account.service_id' | translate }}</mat-label>
        <input matInput formControlName="serviceId" type="text" required />
        <mat-error *ngIf="form.get('serviceId')?.hasError('required')">
          {{ 'brand_name.edit_account.required_serviceId' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'brand_name.edit_account.type' | translate }}</mat-label>
        <input matInput formControlName="type" type="text" readonly />
      </mat-form-field>

      <!-- Submit Button -->
      <div class="button-group" style="display: flex; justify-content: center; margin-top: 20px;">
        <button mat-stroked-button color="primary" class="close-button" type="button" (click)="onNoClick()">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{ 'brand_name.edit_account.button_close' | translate }}
        </button>

        <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid" (click)="updateBrandName(data)" class="custom-button">
          {{ 'brand_name.edit_account.button_save' | translate }}
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
